exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Guest/Desktop/meme/src/app/russian/russian.component.css
// module id = ../../../../../src/app/russian/russian.component.css
// module chunks = main